<template>
  <span ref="tooltip" class="tooltip" data-toggle="tooltip">
    <i class="icon-question-circle"></i>
    <span class="tooltip__content" :style="customStyle">{{ title }}</span>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/* eslint-disable vue/no-unused-components */
export default defineComponent({
  name: 'SettingTooltip',
  props: {
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '306px',
    },
    textAlign: {
      type: String,
      default: 'left',
    },
  },
  computed: {
    customStyle() {
      return {
        'max-width': this.maxWidth,
        'text-align': this.textAlign,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.tooltip {
  display: inline;
  position: relative;

  .icon-question-circle {
    color: $text-light-disabled;
  }

  &__content {
    display: none;
    justify-content: center;
    background: $dark1;
    border-radius: 3px;
    color: $text-dark-high;
    font-size: 12px;
    line-height: 14px;
    padding: 8px;
    width: max-content;
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
  }

  &:hover {
    .tooltip__content {
      display: flex;
    }

    &::before {
      border: solid;
      border-color: $dark1 transparent;
      border-width: 4px 4px 0 4px;
      content: '';
      left: 50%;
      transform: translateX(-50%);
      bottom: calc(100% + 4px);
      position: absolute;
    }
  }
}
</style>
